import { FeatureSubscriptionType } from 'queries';

export function canAddOrEditClientMatter(
  featureSubscriptionType: FeatureSubscriptionType,
): boolean {
  let check = false;
  switch (featureSubscriptionType) {
    case FeatureSubscriptionType.Trial:
    case FeatureSubscriptionType.Lite:
    case FeatureSubscriptionType.Solo:
    case FeatureSubscriptionType.SoloLegacy:
    case FeatureSubscriptionType.Professional:
    case FeatureSubscriptionType.ProfessionalPlus:
    case FeatureSubscriptionType.SmallFirm:
    case FeatureSubscriptionType.MidLargeFirm:
    case FeatureSubscriptionType.Premium:
      check = true;
      break;
  }
  return check;
}

/**
 * Checks if the task being assigned is included in the user's current subscription plan
 * @param minimumFeatureSubscriptionType - the minimum subscription plan required to assign the task
 * @param usersFeatureSubscriptionType - the user's current subscription plan
 * @returns
 */
export function canAssignTaskToTrustate(
  minimumFeatureSubscriptionType: FeatureSubscriptionType,
  usersFeatureSubscriptionType: FeatureSubscriptionType,
): boolean {
  let check = false;
  // Legacy subscriptions automatically get to push all tasks
  const legacyFeatureSubscription = [
    FeatureSubscriptionType.Premium,
    FeatureSubscriptionType.Unlimited,
    FeatureSubscriptionType.ProfessionalPlus,
    FeatureSubscriptionType.Professional,
    FeatureSubscriptionType.SoloLegacy,
    FeatureSubscriptionType.Lite,
  ];
  if (legacyFeatureSubscription.includes(usersFeatureSubscriptionType)) {
    check = true;
    return check;
  }

  // Trial < Solo < Small < Mid-Large
  switch (minimumFeatureSubscriptionType) {
    case FeatureSubscriptionType.MidLargeFirm:
      check = usersFeatureSubscriptionType === FeatureSubscriptionType.MidLargeFirm;
      break;
    case FeatureSubscriptionType.SmallFirm:
      check =
        usersFeatureSubscriptionType === FeatureSubscriptionType.MidLargeFirm ||
        usersFeatureSubscriptionType === FeatureSubscriptionType.SmallFirm;
      break;
    case FeatureSubscriptionType.Solo:
      check =
        usersFeatureSubscriptionType === FeatureSubscriptionType.MidLargeFirm ||
        usersFeatureSubscriptionType === FeatureSubscriptionType.SmallFirm ||
        usersFeatureSubscriptionType === FeatureSubscriptionType.Solo;
      break;
    case FeatureSubscriptionType.Trial:
      check = true;
      break;
  }
  return check;
}

/**
 * Checks if the user has a subscription plan that enables them to push tasks to Trustate
 * @param featureSubscriptionType
 * @returns
 */
export function canAssignTasks(featureSubscriptionType: FeatureSubscriptionType): boolean {
  let check = false;
  switch (featureSubscriptionType) {
    case FeatureSubscriptionType.Trial:
    case FeatureSubscriptionType.Lite:
    case FeatureSubscriptionType.SoloLegacy:
    case FeatureSubscriptionType.Solo:
    case FeatureSubscriptionType.Professional:
    case FeatureSubscriptionType.ProfessionalPlus:
    case FeatureSubscriptionType.SmallFirm:
    case FeatureSubscriptionType.MidLargeFirm:
    case FeatureSubscriptionType.Premium:
      check = true;
      break;
  }
  return check;
}

export function canShareWithClients(featureSubscriptionType: FeatureSubscriptionType): boolean {
  let check = false;
  switch (featureSubscriptionType) {
    case FeatureSubscriptionType.Trial:
    case FeatureSubscriptionType.Lite:
    case FeatureSubscriptionType.SoloLegacy:
    case FeatureSubscriptionType.Solo:
    case FeatureSubscriptionType.Professional:
    case FeatureSubscriptionType.ProfessionalPlus:
    case FeatureSubscriptionType.SmallFirm:
    case FeatureSubscriptionType.MidLargeFirm:
    case FeatureSubscriptionType.Premium:
      check = true;
      break;
  }
  return check;
}

export function canCollabWithTeamMembers(
  featureSubscriptionType: FeatureSubscriptionType,
): boolean {
  let check = false;
  switch (featureSubscriptionType) {
    case FeatureSubscriptionType.Trial:
    case FeatureSubscriptionType.Lite:
    case FeatureSubscriptionType.SoloLegacy:
    case FeatureSubscriptionType.Solo:
    case FeatureSubscriptionType.Professional:
    case FeatureSubscriptionType.ProfessionalPlus:
    case FeatureSubscriptionType.SmallFirm:
    case FeatureSubscriptionType.MidLargeFirm:
    case FeatureSubscriptionType.Premium:
      check = true;
      break;
  }
  return check;
}

export function canAddPointPerson(featureSubscriptionType: FeatureSubscriptionType): boolean {
  let check = false;
  switch (featureSubscriptionType) {
    case FeatureSubscriptionType.Trial:
    case FeatureSubscriptionType.Lite:
    case FeatureSubscriptionType.SoloLegacy:
    case FeatureSubscriptionType.Solo:
    case FeatureSubscriptionType.Professional:
    case FeatureSubscriptionType.ProfessionalPlus:
    case FeatureSubscriptionType.SmallFirm:
    case FeatureSubscriptionType.MidLargeFirm:
    case FeatureSubscriptionType.Premium:
      check = true;
      break;
  }
  return check;
}

export function canIntegrateWithCalendar(
  featureSubscriptionType: FeatureSubscriptionType,
): boolean {
  let check = false;
  switch (featureSubscriptionType) {
    case FeatureSubscriptionType.Trial:
    case FeatureSubscriptionType.Lite:
    case FeatureSubscriptionType.SoloLegacy:
    case FeatureSubscriptionType.Solo:
    case FeatureSubscriptionType.Professional:
    case FeatureSubscriptionType.ProfessionalPlus:
    case FeatureSubscriptionType.SmallFirm:
    case FeatureSubscriptionType.MidLargeFirm:
    case FeatureSubscriptionType.Premium:
      check = true;
      break;
  }
  return check;
}

export function canCreateFirmSpecificTasks(
  featureSubscriptionType: FeatureSubscriptionType,
): boolean {
  let check = false;
  switch (featureSubscriptionType) {
    case FeatureSubscriptionType.Trial:
    case FeatureSubscriptionType.Lite:
    case FeatureSubscriptionType.SoloLegacy:
    case FeatureSubscriptionType.Solo:
    case FeatureSubscriptionType.Professional:
    case FeatureSubscriptionType.ProfessionalPlus:
    case FeatureSubscriptionType.SmallFirm:
    case FeatureSubscriptionType.MidLargeFirm:
    case FeatureSubscriptionType.Premium:
      check = true;
      break;
  }
  return check;
}

export function canModifyBalanceSheet(featureSubscriptionType: FeatureSubscriptionType): boolean {
  let check = false;
  switch (featureSubscriptionType) {
    case FeatureSubscriptionType.Trial:
    case FeatureSubscriptionType.Lite:
    case FeatureSubscriptionType.SoloLegacy:
    case FeatureSubscriptionType.Solo:
    case FeatureSubscriptionType.Professional:
    case FeatureSubscriptionType.ProfessionalPlus:
    case FeatureSubscriptionType.SmallFirm:
    case FeatureSubscriptionType.MidLargeFirm:
    case FeatureSubscriptionType.Premium:
      check = true;
      break;
  }
  return check;
}
